import canvas from '@classes/canvas'
import Logger from '@logger'
import { degreesToRadians } from '@turf/helpers'

import { divideIfNotZero } from '../helper/canvasDraw'
import type { MainParams, StyleParams } from '../Meter'
import type { GaugeDrawResult } from './gauge_types'

const logger = Logger.create('Gauges/Pressure')

export function drawPressureGauge (mainParams: MainParams, styleParams: StyleParams): GaugeDrawResult {
  const { prevValue, value, maxValue, minValue, center, radius, dpx, ctx, formatter, redraw, unit, currentValue }
    = mainParams
  const { arcColor, color } = styleParams
  let dd: number, start: number, end: number, startAngle: number, progressAngle: number
  let newCurrentValue: number = currentValue

  const lengthInDegrees = 40
  const from = Number(prevValue)
  const to = Number(value)

  const drawing = (current: number) => {
    newCurrentValue = current
    dd = divideIfNotZero(270, Number(maxValue) - Number(minValue))
    start = 135 + dd * (current - Number(minValue))
    end = start - lengthInDegrees
    startAngle = degreesToRadians(end)
    progressAngle = degreesToRadians(start)

    logger.debug(`pressure => startAngle=${startAngle}, progressAngle=${progressAngle}`)

    const startXY = canvas.xy(start + 90, center, radius - 8)
    const endXY = canvas.xy(start + 90, center - 2, radius - dpx * 60)
    const circleBeginAngle = degreesToRadians(135)
    const circleEndAngle = degreesToRadians(270 + 135)
    const value = newCurrentValue ? ctx.measureText(formatter(newCurrentValue)) : ctx.measureText('0')

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    redraw()
    canvas.drawValue(
      ctx,
      center - Number(value.width) / newCurrentValue.toString().length - 6 * dpx,
      center + 19 * dpx,
      formatter(newCurrentValue),
      14 * dpx,
      color
    )
    canvas.drawHand(ctx, startXY.x, startXY.y, endXY.x, endXY.y, dpx * 1.3, color)
    canvas.drawArc(ctx, center, center, radius, circleBeginAngle - 3, circleEndAngle, 'transparent', dpx + 1)
    canvas.drawArc(ctx, center, center, radius, circleBeginAngle, circleEndAngle, arcColor, dpx + 1)
    canvas.drawArc(ctx, center - 1.5, center - 1.5, dpx * 3, 0, Math.PI * 2, arcColor, dpx, arcColor)
    unit
      && canvas.drawUnit(
        ctx,
        center + Number(value.width) / 2 + newCurrentValue.toFixed().length * dpx,
        center + 19 * dpx + dpx,
        unit,
        dpx * 9,
        color
      )
  }

  const animateId = canvas.animate(from, to, drawing, 2, 'pressure')

  return { animateId, newCurrentValue }
}
